import { Flex, Image, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import notResult from '../../../../assets/images/not-result.webp';

const { Paragraph } = Typography;

const NotResultsFound = () => {
  const { t } = useTranslation();

  return (
    <Flex flex={1} justify="center" align="center" gap={32} vertical>
      <Image
        preview={false}
        width={128}
        height={128}
        alt={t('no_results_found')}
        src={notResult}
      />
      <Paragraph>{t('patient.no_results_found')}</Paragraph>
    </Flex>
  );
};

export default NotResultsFound;
